module.exports = __webpack_public_path__ + "6dded2e514826f50f5a456450c598690.svg";


//////////////////
// WEBPACK FOOTER
// ./images/inactive-icon.svg
// module id = 1073
// module chunks = 0